import { Badge, Table } from "flowbite-react";
import { formatToReal } from "../../../utils/utils";

/* Cargo e Fonte só existem quando os administradores vêm dos birôs padrão ou da
   visão consolidada por tipo (todas as fontes na mesma tabela). Nos demais usos
   as colunas não aparecem. */
const Administrador = ({ administradores }) => {
  const vazio = (v) => v == null || v === "" || v === "-";
  const temCargo = administradores?.some((a) => !vazio(a?.cargo));
  const temFonte = administradores?.some((a) => !vazio(a?.fonte));

  return (
    <>
      <div className="overflow-x-hidden border-gray-300 border rounded-lg mt-3">
        <Table striped>
          <Table.Head className="text-black">
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Nº
            </Table.HeadCell>
            <Table.HeadCell className="py-2" style={{ background: "#EBF5FF" }}>
              Nome
            </Table.HeadCell>
            {temCargo && (
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Cargo
            </Table.HeadCell>
            )}
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Data <br /> Entrada
            </Table.HeadCell>
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Débitos
              <br />
              (S/N)
            </Table.HeadCell>
            <Table.HeadCell className="py-2" style={{ background: "#EBF5FF" }}>
              Pendências
            </Table.HeadCell>
            {temFonte && (
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Fonte
            </Table.HeadCell>
            )}
          </Table.Head>
          {administradores?.length > 0 && (
            <Table.Body className="divide-y">
              {administradores?.map((socio, index) => (
                <Table.Row
                  key={index}
                  className="bg-white dark:border-gray-700 dark:bg-gray-800 text-black"
                >
                  <Table.Cell className="font-medium dark:text-white text-center py-1 px-1">
                    {index + 1}
                  </Table.Cell>
                  <Table.Cell className=" py-1">
                    <div>{socio?.nome || "-"}</div>
                    <div style={{ fontSize: "10px" }}>CPF: {socio?.cpf}</div>
                  </Table.Cell>
                  {temCargo && (
                    <Table.Cell className="text-center py-1 px-1">
                      {socio?.cargo || "-"}
                    </Table.Cell>
                  )}
                  <Table.Cell className="text-center py-1 px-1">
                    {socio?.entrada || "-"}
                  </Table.Cell>
                  <Table.Cell className="text-center py-1 px-1">
                    {socio?.indicador_debito?.toLowerCase() === "sim" ? (
                      <div className="text-red-600 mx-auto">
                        {socio?.indicador_debito || "-"}
                      </div>
                    ) : (
                      <div className="text-blue-600 mx-auto font-semibold">
                        {socio?.indicador_debito || "-"}
                      </div>
                    )}
                  </Table.Cell>
                  <Table.Cell className="py-1 text-2xs text-black">
                    {socio?.indicador_debito?.toUpperCase() === "SIM" ? (
                      <>
                        {socio?.restricoes_documento?.cheques_sem_fundo
                          ?.quantidade !== "0" && (
                          <div className="uppercase">
                            Cheques Sem Fundos:{" "}
                            <span className="text-red-500 font-semibold">
                              {
                                socio?.restricoes_documento?.cheques_sem_fundo
                                  ?.quantidade
                              }{" "}
                              ocorrências
                            </span>
                          </div>
                        )}

                        {socio?.restricoes_documento?.protestos?.quantidade !==
                          "0" && (
                          <div className="uppercase">
                            Protestos:{" "}
                            <span className="text-red-500 font-semibold">
                              {formatToReal(
                                socio?.restricoes_documento?.protestos?.valor
                              )}
                            </span>
                          </div>
                        )}

                        {socio?.restricoes_documento?.pendencias_restricoes
                          ?.quantidade !== "0" && (
                          <div className="uppercase">
                            Pendências:{" "}
                            <span className="text-red-500 font-semibold">
                              {formatToReal(
                                socio?.restricoes_documento
                                  ?.pendencias_restricoes?.valor
                              )}
                            </span>
                          </div>
                        )}

                        {socio?.restricoes_documento?.acoes_judiciais
                          ?.quantidade !== "0" && (
                          <div className="uppercase">
                            Ações cíveis:{" "}
                            <span className="text-red-500 font-semibold">
                              {formatToReal(
                                socio?.restricoes_documento?.acoes_judiciais
                                  ?.valor
                              )}
                            </span>
                          </div>
                        )}

                        {socio?.restricoes_documento
                          ?.falencias_recuperacao_judicial?.quantidade !==
                          "0" && (
                          <div className="uppercase">
                            Rec. Judicial/Falências:{" "}
                            <span className="text-red-500 font-semibold">
                              {formatToReal(
                                socio?.restricoes_documento
                                  ?.falencias_recuperacao_judicial?.valor
                              )}
                            </span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text-blue-500">Não há débitos</div>
                    )}
                  </Table.Cell>
                  {temFonte && (
                    <Table.Cell className="text-center py-1 px-1 text-2xs">
                      {socio?.fonte || "-"}
                    </Table.Cell>
                  )}
                </Table.Row>
              ))}
            </Table.Body>
          )}
        </Table>
      </div>
    </>
  );
};

export default Administrador;
